export class QuestionMetadata {
  loadTimestamp: number;
  unloadTimestamp: number;
}
